import { ElAffix } from '@pit-element-plus/components/affix'
import { ElAlert } from '@pit-element-plus/components/alert'
import { ElAutocomplete } from '@pit-element-plus/components/autocomplete'
import { ElAvatar, ElAvatarGroup } from '@pit-element-plus/components/avatar'
import { ElBacktop } from '@pit-element-plus/components/backtop'
import { ElBadge } from '@pit-element-plus/components/badge'
import { ElBaseTabs } from '@pit-element-plus/components/base-tabs'
import {
  ElBreadcrumb,
  ElBreadcrumbItem,
} from '@pit-element-plus/components/breadcrumb'
import { ElButton, ElButtonGroup } from '@pit-element-plus/components/button'
import { ElCalendar } from '@pit-element-plus/components/calendar'
import { ElCard } from '@pit-element-plus/components/card'
import {
  ElCarousel,
  ElCarouselItem,
} from '@pit-element-plus/components/carousel'
import { ElCascader } from '@pit-element-plus/components/cascader'
import { ElCascaderPanel } from '@pit-element-plus/components/cascader-panel'
import { ElCheckTag } from '@pit-element-plus/components/check-tag'
import {
  ElCheckbox,
  ElCheckboxButton,
  ElCheckboxGroup,
} from '@pit-element-plus/components/checkbox'
import { ElCol } from '@pit-element-plus/components/col'
import {
  ElCollapse,
  ElCollapseItem,
} from '@pit-element-plus/components/collapse'
import { ElCollapseTransition } from '@pit-element-plus/components/collapse-transition'
import { ElColorPickerPanel } from '@pit-element-plus/components/color-picker-panel'
import { ElColorPicker } from '@pit-element-plus/components/color-picker'
import { ElConfigProvider } from '@pit-element-plus/components/config-provider'
import {
  ElAside,
  ElContainer,
  ElFooter,
  ElHeader,
  ElMain,
} from '@pit-element-plus/components/container'
import { ElDatePicker } from '@pit-element-plus/components/date-picker'
import { ElDatePickerPanel } from '@pit-element-plus/components/date-picker-panel'
import {
  ElDescriptions,
  ElDescriptionsItem,
} from '@pit-element-plus/components/descriptions'
import { ElDialog } from '@pit-element-plus/components/dialog'
import { ElDialogHeader } from '@pit-element-plus/components/dialog-header'
import { ElDivider } from '@pit-element-plus/components/divider'
import { ElDrawer } from '@pit-element-plus/components/drawer'
import {
  ElDropdown,
  ElDropdownItem,
  ElDropdownMenu,
} from '@pit-element-plus/components/dropdown'
import { ElEmpty } from '@pit-element-plus/components/empty'
import { ElForm, ElFormItem } from '@pit-element-plus/components/form'
import { ElFormBase } from '@pit-element-plus/components/form-base'
import { ElIcon } from '@pit-element-plus/components/icon'
import { ElImage } from '@pit-element-plus/components/image'
import { ElImageViewer } from '@pit-element-plus/components/image-viewer'
import { ElInput } from '@pit-element-plus/components/input'
import { ElInputNumber } from '@pit-element-plus/components/input-number'
import { ElInputTag } from '@pit-element-plus/components/input-tag'
import { ElLink } from '@pit-element-plus/components/link'
import { ElLayoutColumn } from '@pit-element-plus/components/layout-column'
import { ElLayoutTree } from '@pit-element-plus/components/layout-tree'
import {
  ElMenu,
  ElMenuItem,
  ElMenuItemGroup,
  ElSubMenu,
} from '@pit-element-plus/components/menu'
import { ElPageHeader } from '@pit-element-plus/components/page-header'
import { ElPagination } from '@pit-element-plus/components/pagination'
import { ElPopconfirm } from '@pit-element-plus/components/popconfirm'
import { ElPopover } from '@pit-element-plus/components/popover'
import { ElPopper } from '@pit-element-plus/components/popper'
import { ElProgress } from '@pit-element-plus/components/progress'
import {
  ElRadio,
  ElRadioButton,
  ElRadioGroup,
} from '@pit-element-plus/components/radio'
import { ElRate } from '@pit-element-plus/components/rate'
import { ElResult } from '@pit-element-plus/components/result'
import { ElRow } from '@pit-element-plus/components/row'
import { ElScrollbar } from '@pit-element-plus/components/scrollbar'
import {
  ElOption,
  ElOptionGroup,
  ElSelect,
} from '@pit-element-plus/components/select'
import { ElSelectV2 } from '@pit-element-plus/components/select-v2'
import {
  ElSkeleton,
  ElSkeletonItem,
} from '@pit-element-plus/components/skeleton'
import { ElSlider } from '@pit-element-plus/components/slider'
import { ElSpace } from '@pit-element-plus/components/space'
import { ElStatistic } from '@pit-element-plus/components/statistic'
import { ElCountdown } from '@pit-element-plus/components/countdown'
import { ElStep, ElSteps } from '@pit-element-plus/components/steps'
import { ElSwitch } from '@pit-element-plus/components/switch'
import { ElTable, ElTableColumn } from '@pit-element-plus/components/table'
import { ElAutoResizer, ElTableV2 } from '@pit-element-plus/components/table-v2'
import { ElTabPane, ElTabs } from '@pit-element-plus/components/tabs'
import { ElTag } from '@pit-element-plus/components/tag'
import { ElText } from '@pit-element-plus/components/text'
import { ElTimePicker } from '@pit-element-plus/components/time-picker'
import { ElTimeSelect } from '@pit-element-plus/components/time-select'
import {
  ElTimeline,
  ElTimelineItem,
} from '@pit-element-plus/components/timeline'
import { ElTooltip } from '@pit-element-plus/components/tooltip'
import { ElTransfer } from '@pit-element-plus/components/transfer'
import { ElTree } from '@pit-element-plus/components/tree'
import { ElTreeSelect } from '@pit-element-plus/components/tree-select'
import { ElTreeV2 } from '@pit-element-plus/components/tree-v2'
import { ElUpload } from '@pit-element-plus/components/upload'
import { ElWatermark } from '@pit-element-plus/components/watermark'
import { ElTour, ElTourStep } from '@pit-element-plus/components/tour'
import { ElAnchor, ElAnchorLink } from '@pit-element-plus/components/anchor'
import { ElSegmented } from '@pit-element-plus/components/segmented'
import { ElMention } from '@pit-element-plus/components/mention'
import {
  ElSplitter,
  ElSplitterPanel,
} from '@pit-element-plus/components/splitter'

import type { Plugin } from 'vue'

export default [
  ElAffix,
  ElAlert,
  ElAutocomplete,
  ElAutoResizer,
  ElAvatar,
  ElAvatarGroup,
  ElBacktop,
  ElBadge,
  ElBaseTabs,
  ElBreadcrumb,
  ElBreadcrumbItem,
  ElButton,
  ElButtonGroup,
  ElCalendar,
  ElCard,
  ElCarousel,
  ElCarouselItem,
  ElCascader,
  ElCascaderPanel,
  ElCheckTag,
  ElCheckbox,
  ElCheckboxButton,
  ElCheckboxGroup,
  ElCol,
  ElCollapse,
  ElCollapseItem,
  ElCollapseTransition,
  ElColorPickerPanel,
  ElColorPicker,
  ElConfigProvider,
  ElContainer,
  ElAside,
  ElFooter,
  ElHeader,
  ElMain,
  ElDatePicker,
  ElDatePickerPanel,
  ElDescriptions,
  ElDescriptionsItem,
  ElDialog,
  ElDialogHeader,
  ElDivider,
  ElDrawer,
  ElDropdown,
  ElDropdownItem,
  ElDropdownMenu,
  ElEmpty,
  ElForm,
  ElFormItem,
  ElFormBase,
  ElIcon,
  ElImage,
  ElImageViewer,
  ElInput,
  ElInputNumber,
  ElInputTag,
  ElLink,
  ElLayoutColumn,
  ElLayoutTree,
  ElMenu,
  ElMenuItem,
  ElMenuItemGroup,
  ElSubMenu,
  ElPageHeader,
  ElPagination,
  ElPopconfirm,
  ElPopover,
  ElPopper,
  ElProgress,
  ElRadio,
  ElRadioButton,
  ElRadioGroup,
  ElRate,
  ElResult,
  ElRow,
  ElScrollbar,
  ElSelect,
  ElOption,
  ElOptionGroup,
  ElSelectV2,
  ElSkeleton,
  ElSkeletonItem,
  ElSlider,
  ElSpace,
  ElStatistic,
  ElCountdown,
  ElSteps,
  ElStep,
  ElSwitch,
  ElTable,
  ElTableColumn,
  ElTableV2,
  ElTabs,
  ElTabPane,
  ElTag,
  ElText,
  ElTimePicker,
  ElTimeSelect,
  ElTimeline,
  ElTimelineItem,
  ElTooltip,
  ElTransfer,
  ElTree,
  ElTreeSelect,
  ElTreeV2,
  ElUpload,
  ElWatermark,
  ElTour,
  ElTourStep,
  ElAnchor,
  ElAnchorLink,
  ElSegmented,
  ElMention,
  ElSplitter,
  ElSplitterPanel,
] as Plugin[]
